import { render, staticRenderFns } from "./inquiryDetail.vue?vue&type=template&id=4d7aa9af&scoped=true"
import script from "./inquiryDetail.vue?vue&type=script&lang=js"
export * from "./inquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./inquiryDetail.vue?vue&type=style&index=0&id=4d7aa9af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7aa9af",
  null
  
)

export default component.exports